import type {Schemas} from 'domainTypes/dto';

export const getIdsFromAction = (
  dto:
    | Schemas.BulkUpdateActionAdd
    | Schemas.BulkUpdateActionRemove
    | Schemas.BulkUpdateActionReplace,
): string[] => {
  return ((dto as Schemas.BulkUpdateActionAdd)?.addValues ?? []).concat(
    (dto as Schemas.BulkUpdateActionRemove)?.removeValues ?? [],
    (dto as Schemas.BulkUpdateActionReplace)?.updatedValues ?? [],
  );
};
